import './index.css';
import { App } from './app/App.tsx';
import { store } from 'lotto-shared';
import { Provider } from 'react-redux';
import { TgApp } from './app/TgApp.tsx';
import { createRoot } from 'react-dom/client';
import 'lotto-shared/src/i18n';

createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <TgApp>
      <App />
    </TgApp>
  </Provider>,
);
